import React from 'react';
import { Card } from 'react-bootstrap';
import { VerticalSeparator } from '../components/separators';
import './services.css';

import { ReactComponent as AirConditionerIcon } from '../icons/air_conditioner_color.svg';
import { ReactComponent as BarbecueIcon } from '../icons/barbecue_color.svg';
import { ReactComponent as WifiIcon } from '../icons/wifi_color.svg';
import { ReactComponent as WashingMachineIcon } from '../icons/washing_machine_color.svg';
import { ReactComponent as TvIcon } from '../icons/tv_color.svg';
import { ReactComponent as OutdoorTableIcon } from '../icons/outdoor_table_color.svg';
import { ReactComponent as BicycleIcon } from '../icons/bicycle_color.svg';
import { ReactComponent as AsciugacapelliIcon } from '../icons/asciugacapelli.svg';
import { ReactComponent as AsciugamaniIcon } from '../icons/asciugamani.svg';
import { ReactComponent as BilanciaIcon } from '../icons/bilancia.svg';
import { ReactComponent as DocciaIcon } from '../icons/doccia.svg';
import { ReactComponent as FerroDaStiroIcon } from '../icons/ferro_da_stiro.svg';
import { ReactComponent as FornoIcon } from '../icons/forno.svg';
import { ReactComponent as FrigoIcon } from '../icons/frigorifero.svg';
import { ReactComponent as CaffeIcon } from '../icons/macchinetta_caffe.svg';
import { ReactComponent as OmbrelloneIcon } from '../icons/ombrellone_spiaggia.svg';
import SpremiAgrumiIcon from '../icons/spremi_agrumi.png';
import BollitoreiIcon from '../icons/bollitore.png';
import TerrazzaIcon from '../icons/terrazza.png';

const ServicesComponent = (props) => {

    const { selectedLanguage } = props;

    return (
        <Card fluid='true' style={{ backgroundColor: '#e0e0e0', marginLeft: '12px', marginRight: '12px' }}>
            <VerticalSeparator height={"2vw"}></VerticalSeparator>
            <h1 className='text-h-services-class' style={{ textAlign: 'center' }}>{selectedLanguage === 'ita' ? "I nostri servizi" : "Our services"}</h1>
            <VerticalSeparator height={"2vw"}></VerticalSeparator>
            <div className="services-grid">
                <div className="service-item">
                    <AirConditionerIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Aria condizionata" : "Air conditioning"}</p>
                </div>
                <div className="service-item">
                    <WifiIcon className="icon" />
                    <p className='text-p-services-class'>Wi-Fi</p>
                </div>
                <div className="service-item">
                    <img src={TerrazzaIcon} alt='' className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Veranda" : "Veranda"}</p>
                </div>
                <div className="service-item">
                    <OutdoorTableIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Tavolo esterno" : "Outdoor table"}</p>
                </div>
                <div className="service-item">
                    <BarbecueIcon className="icon" />
                    <p className='text-p-services-class'>Barbecue</p>
                </div>
                <div className="service-item">
                    <FornoIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Forno" : "Oven"}</p>
                </div>
                <div className="service-item">
                    <FrigoIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Frigorifero" : "Refrigerator"}</p>
                </div>
                <div className="service-item">
                    <BilanciaIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Bilancia da cucina" : "kitchen scale"}</p>
                </div>
                <div className="service-item">
                    <img src={SpremiAgrumiIcon} alt='' className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Spremiagrumi" : "Citrus juicer"}</p>
                </div>
                <div className="service-item">
                    <CaffeIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Macchinetta del caffè" : "Coffee machine"}</p>
                </div>
                <div className="service-item">
                    <img src={BollitoreiIcon} alt='' className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Bollitore" : "Kettle"}</p>
                </div>
                <div className="service-item">
                    <TvIcon className="icon" />
                    <p className='text-p-services-class'>TV</p>
                </div>
                <div className="service-item">
                    <WashingMachineIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Lavatrice" : "Washing machine"}</p>
                </div>
                <div className="service-item">
                    <FerroDaStiroIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Ferro da stiro" : "Iron"}</p>
                </div>
                <div className="service-item">
                    <OmbrelloneIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Attrezzature per la spiaggia" : "Beach equipment"}</p>
                </div>
                <div className="service-item">
                    <DocciaIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Doccia" : "Shower"}</p>
                </div>
                <div className="service-item">
                    <AsciugamaniIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Asciugamani e lenzuola" : "Towels and sheets"}</p>
                </div>
                <div className="service-item">
                    <AsciugacapelliIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Asciugacapelli" : "Hair dryer"}</p>
                </div>
                <div className="service-item">
                    <BicycleIcon className="icon" />
                    <p className='text-p-services-class'>{selectedLanguage === 'ita' ? "Biciclette" : "Bicycles"}</p>
                </div>
            </div>
            <VerticalSeparator height={"2vw"}></VerticalSeparator>
        </Card>
    );
}

export default ServicesComponent;